const entryPriceRows = (entry) => (entry && entry.productPrices && entry.productPrices.data) || [];

export const saleRowsFrom = (payload) => {
  const rows = {};

  ((payload && payload.data) || []).forEach((entry) => {
    entryPriceRows(entry).forEach((price) => {
      if (!price || price.id == null || price.count == null) return;

      rows[price.id] = {
        productPriceId: price.id,
        productId: entry.id,
        count: Number(price.count) || 0,
        unitPrice: Number(price.unitPrice) || 0,
        sum: Number(price.sum) || 0,
        freeCount: Number(price.freeCount) || 0,
        inThirdFree: !!price.inThirdFree,
        appliedDiscount: Number(price.appliedDiscount) || 0,
        oldPrice: price.oldPrice == null ? null : Number(price.oldPrice),
        oldSum: price.oldSum == null ? null : Number(price.oldSum),
        price: Number(price.price) || 0,
        basePrice: Number(price.basePrice) || 0
      };
    });
  });

  return rows;
};

export const salePromoFrom = (payload) => {
  const promo = payload && payload.promo;
  if (!promo) return null;

  return {
    active: !!promo.active,
    freeUnits: Number(promo.freeUnits) || 0,
    unitsToNext: Number(promo.unitsToNext) || 0,
    unitsInBasket: Number(promo.unitsInBasket) || 0,
    discount: Number(promo.discount) || 0
  };
};

export const saleRaffleFrom = (payload) => {
  const raffle = payload && payload.raffle;
  if (!raffle) return null;

  return {
    amount: Number(raffle.amount) || 0,
    tickets: Number(raffle.tickets) || 0,
    leftToNext: raffle.leftToNext == null ? null : Number(raffle.leftToNext),
    step: Number(raffle.step) || 0,
    maxTickets: Number(raffle.maxTickets) || 0,
    isMax: !!raffle.isMax,
    icon: raffle.icon || null
  };
};

export const hasVisibleDiscount = (price) =>
  !!price && price.appliedDiscount > 0 && !!price.oldPrice && price.oldPrice > price.price;
